// extracted by mini-css-extract-plugin
export default {"form":"select_form__WoGye","label":"select_label__epeIb","select":"select_select__PkSpO"};